import { render, staticRenderFns } from "./suppliers.vue?vue&type=template&id=2ca4b26c&scoped=true"
import script from "./suppliers.vue?vue&type=script&lang=js"
export * from "./suppliers.vue?vue&type=script&lang=js"
import style0 from "./suppliers.vue?vue&type=style&index=0&id=2ca4b26c&prod&lang=css"
import style1 from "./suppliers.vue?vue&type=style&index=1&id=2ca4b26c&prod&lang=css"
import style2 from "./suppliers.vue?vue&type=style&index=2&id=2ca4b26c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca4b26c",
  null
  
)

export default component.exports